import ComponentsManager from "./ComponentsManager.js"
import {getCurrentLanguage} from "../../Utils/Utils.js";

class LanguageManager {
    // TODO: If logged use the backend language.
    #preferedLanguage = getCurrentLanguage()
    #btnLangMap = {en: '🇬🇧 EN', fr: '🇫🇷 FR', de: '🇩🇪 DE', es: '🇪🇸 ES'}

    /**
     * @author Corentin (ccharton) Charton
     * @description Construct the LanguageManager module
     */
    constructor() {
        if (!this.#preferedLanguage || !this.#btnLangMap[this.#preferedLanguage]) {
            this.#preferedLanguage = 'en'
            localStorage.setItem('language', this.#preferedLanguage)
        }
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Update the content of the page to the prefered
     */
    async updateContent() {
        const langBtn = document.getElementById('languageDropupBtn')
        if (langBtn) {
            langBtn.innerHTML = this.#btnLangMap[this.#preferedLanguage]
        }

        const visibleComponents = ComponentsManager.getVisibleComponents()

        for (const selector of visibleComponents) {
            const langData = await this.fetchLanguageData(this.#preferedLanguage, selector.replace('#', ''))

            if (!langData) {
                continue
            }

            const elements = document.querySelectorAll(`${selector} [data-i18n]`)
            elements.forEach(element => {
                const key = element.getAttribute('data-i18n')
                if (langData[key]) {
                    if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
                        element.placeholder = langData[key]
                    } else {
                        this.replaceTextOnly(element, langData[key])
                    }
                }
            })
        }
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Replace the text content of an element, without removing its children
     * @param element {Element} - The element to replace the text of
     * @param newText {string} - The new text to set
     */
    replaceTextOnly(element, newText) {
        let hasTextNode = false

        element.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
                node.textContent = newText
                hasTextNode = true
            }
        })

        if (!hasTextNode) {
            element.appendChild(document.createTextNode(newText))
        }
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Set the language preference
     * @param lang {string} - The language to set
     */
    setLanguagePreference(lang) {
        this.#preferedLanguage = lang
        localStorage.setItem('language', lang)
        // TODO: Set it in the Backend if logged
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Fetch the language data for a specific module
     * @param lang {string} - The language to fetch
     * @param module {string} - The module to fetch
     * @returns {Promise<{}>} - The language data
     */
    async fetchLanguageData(lang, module) {
        try {
            const response = await fetch(`../../locales/${lang}/${module}.json`)
            if (!response.ok) {
                throw new Error(`Failed to load ${module}.json`)
            }
            return await response.json()
        } catch (error) {
            console.error(`Error while loading ${module}.json: ${error}`)
            return {}
        }
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Change the language of the page
     * @param lang {string} - The language to switch to
     */
    async changeLanguage(lang) {
        this.setLanguagePreference(lang)
        window.dispatchEvent(new Event('languageChanged'))
        await this.updateContent()
    }
}

export default new LanguageManager()